import { ChatBubble } from '../../model/chat-bubble.model';

// small, but important
export function createFilteredQuotesLookup(
    quotes: ChatBubble[],
    selectedQuotes: ChatBubble[],
): { lookup: { [index: number]: boolean }; all: boolean } {
    const lookup =
        quotes?.map((e) => {
            return selectedQuotes == null ? false : selectedQuotes.includes(e);
        }) ?? {};
    const all =
        quotes != null && selectedQuotes != null
            ? quotes?.length === selectedQuotes?.length
            : false;
    return { lookup, all };
}
